import React, { memo } from 'react';
import styled from 'styled-components';

import Name from '../../Clients/Name/Name';
import TimeFrom from '../../Common/TimeFrom';

import { CLIENT_LOG_TYPES } from '../../../../constants';

import { Mail, Message, Note } from '@icons/communication';
import { ValueOf } from '@utils/tsUtils';

interface ICommunicationSearchCard {
  className?: string;
  time: Date | number;
  id: string;
  name?: string;
  disabled: boolean;
  message: string;
  subject: string;
  type: ValueOf<typeof CLIENT_LOG_TYPES>;
  isIncoming?: boolean;
}

const CommunicationSearchCard = ({
  time,
  className,
  subject,
  message,
  id,
  name = '',
  type = CLIENT_LOG_TYPES.EMAIL,
  isIncoming = true,
  ...props
}: ICommunicationSearchCard) => {
  let icon;
  switch (type) {
    case CLIENT_LOG_TYPES.EMAIL:
      icon = <StyledMailIcon />;
      break;
    case CLIENT_LOG_TYPES.NOTE:
      icon = <StyledNoteIcon />;
      break;
    case CLIENT_LOG_TYPES.SMS:
    case CLIENT_LOG_TYPES.MESSAGE:
      icon = <StyledMessageIcon />;
      break;
    default:
      icon = null;
  }

  const isNumberTime = typeof time === 'number';

  return (
    <StyledCommunicationSearchCard className={className} {...props}>
      <StyledContact>
        {type !== CLIENT_LOG_TYPES.NOTE && (
          <StyledSubject dangerouslySetInnerHTML={{ __html: subject }} />
        )}
        {id && <StyledIdentifier title={id}>{id}</StyledIdentifier>}
        <StyledName name={name} />
      </StyledContact>
      <StyledCommunication>
        <StyledMessage
          title={message}
          dangerouslySetInnerHTML={{ __html: message }}
        />
        {isIncoming && <StyledType>Входящие</StyledType>}
        {isNumberTime && <StyledTime time={time} />}
        {icon}
      </StyledCommunication>
    </StyledCommunicationSearchCard>
  );
};

const StyledCommunicationSearchCard = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: 44px;
  background-color: #fff;

  mark {
    background-color: transparent;
    font-weight: bold;
  }
`;

const StyledIdentifier = styled.div`
  margin-right: 9px;
  font-size: 14px;
  line-height: 1.29;
  letter-spacing: normal;
  color: #919499;
  ::before {
    content: '#';
  }
`;

const StyledName = styled(Name)`
  color: #919499;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
  text-overflow: ellipsis;
  font-weight: normal;
`;

const StyledCommunication = styled.div`
  display: flex;
  width: 100%;
  height: 18px;
  color: #919499;
  margin-bottom: 5px;
  line-height: 18px;
`;

const StyledTime = styled(TimeFrom)`
  white-space: nowrap;
  margin-left: 10px;
  line-height: 20px;
`;

const StyledContact = styled.div`
  display: flex;
  width: 100%;
  height: 18px;
  font-size: 14px;
  margin-top: 5px;
`;

const StyledMailIcon = styled(Mail)`
  margin-top: 2px;
  min-width: 14px;
  height: 14px;
  width: auto;
  margin-left: 10px;
`;

const StyledMessageIcon = styled(Message)`
  min-width: 14px;
  margin-top: 2px;
  height: 14px;
  width: auto;
  margin-left: 10px;
`;

const StyledNoteIcon = styled(Note)`
  min-width: 14px;
  margin-top: 2px;
  height: 14px;
  width: auto;
  margin-left: 10px;
`;

const StyledSubject = styled.span`
  color: #4d4d4d;
  font-size: 14px;
  overflow: hidden;
  height: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-grow: 1;
`;

const StyledMessage = styled.div`
  color: #4d4d4d;
  font-size: 14px;
  overflow: hidden;
  height: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-grow: 1;
`;

const StyledType = styled.div`
  margin-left: 11px;
  max-width: 200px;
`;

export default memo(CommunicationSearchCard);
